// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact-Contact--Yt1Xr","Content":"Contact-Content-2W8zHW","Header":"Contact-Header-1F3tDi","Email":"Contact-Email-39NBhI","Subheader":"Contact-Subheader-222Ybw"};